module.exports = __webpack_public_path__ + "img/table.aca008fc.svg";